import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";
import { EmptyRow, LoadingOverlay, RECEIVABLES_API, fmtDateTime, money } from "./common";

/** Field collections whose customer OTP was never confirmed (legacy pending_otp.aspx). */
const PendingOtp = () => {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.get(`${RECEIVABLES_API}/pending-otps`);
      setRows(Array.isArray(data) ? data : []);
    } catch (error) {
      toast.error(error.message || "Failed to load pending OTPs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const needle = search.trim().toLowerCase();
  const visible = needle
    ? rows.filter((row) =>
        [row.customerName, row.beatName, row.salesPersonName, row.invoiceNumber, row.receiptNumber]
          .filter(Boolean)
          .some((value) => value.toLowerCase().includes(needle))
      )
    : rows;

  return (
    <div className="p-4" style={{ position: "relative" }}>
      <LoadingOverlay show={loading} label="Loading pending OTPs..." />
      <div className="page-subtitle" style={{ marginBottom: 12 }}>
        Payments collected in the field that are still waiting for the customer's OTP. The latest OTP of each submission is shown.
      </div>
      <div className="filters-bar">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search customer, beat, salesman, invoice..."
        />
        <button className="secondary" onClick={load} disabled={loading}>
          Refresh
        </button>
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th>Beat</th>
              <th>Salesperson</th>
              <th>Invoice</th>
              <th>Receipt</th>
              <th>Type</th>
              <th style={{ textAlign: "right" }}>Amount</th>
              <th>OTP</th>
              <th>Collected At</th>
            </tr>
          </thead>
          <tbody>
            {visible.length === 0 ? (
              <EmptyRow colSpan={10} title="No pending OTPs" />
            ) : (
              visible.map((row, index) => (
                <tr key={row.collectionId}>
                  <td>{index + 1}</td>
                  <td title={row.customerName}>{row.customerName}</td>
                  <td>{row.beatName || "-"}</td>
                  <td>{row.salesPersonName || "-"}</td>
                  <td>{row.invoiceNumber}</td>
                  <td>{row.receiptNumber || "-"}</td>
                  <td>{row.collectionType}</td>
                  <td style={{ textAlign: "right" }}>{money(row.amount)}</td>
                  <td>
                    <strong style={{ letterSpacing: "0.1em" }}>{row.otp}</strong>
                  </td>
                  <td>{fmtDateTime(row.collectedAt)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PendingOtp;
